import { useState } from 'react';
import { useSnackbar } from 'notistack';

import HttpClient from '../../shared/infrastructures/clients/http.client';
import { extractTranslatedApiErrorMessage } from '../../shared/utils/translate-api-error.util';
import { Product } from '../types/product.type';
import { UpdateProductRequestDTO } from '../types/dtos/update-product.dto';
import { ADMIN_PRODUCTS_API_PATHS } from '../constants/products-api-paths.constants';

type UpdateProductParams = {
  productId: string;
  productData: UpdateProductRequestDTO;
};

type UseUpdateProductResult = {
  updateProduct: (params: UpdateProductParams) => Promise<Product | null>;
  isSubmitting: boolean;
};

export function useUpdateProduct(): UseUpdateProductResult {
  const { enqueueSnackbar } = useSnackbar();
  const [isSubmitting, setIsSubmitting] = useState(false);

  const updateProduct = async ({ productId, productData }: UpdateProductParams): Promise<Product | null> => {
    setIsSubmitting(true);

    try {
      const updatedProduct = await HttpClient.patch<Product, UpdateProductRequestDTO>(
        ADMIN_PRODUCTS_API_PATHS.UPDATE_PRODUCT(productId),
        productData
      );

      enqueueSnackbar('Le produit a été mis à jour', { variant: 'success' });
      return updatedProduct;
    } catch (error) {
      enqueueSnackbar(
        extractTranslatedApiErrorMessage(error, 'Une erreur est survenue lors de la mise à jour du produit'),
        { variant: 'error' }
      );
      return null;
    } finally {
      setIsSubmitting(false);
    }
  };

  return { updateProduct, isSubmitting };
}
